import {
    DKLabel,
    DKButton,
    DKInput,
    DKIcon,
    INPUT_VIEW_DIRECTION,
    DKLine,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    showAlert
} from "deskera-ui-library";
import { DATE_FORMAT, INPUT_TYPE } from "../../constants/Constant";
import { PERCENTAGE } from "../../constants/RegexConstants";
import Utility from "../../utility/Utility";
import HIGH from "../../assets/icons/ic_red_trangle.svg";
import MEDIUM from "../../assets/icons/ic_yellow_circle.svg";
import LOW from "../../assets/icons/ic_blue_trangle.svg";
import Range from 'react-range-progress';
import moment from "moment";
export const GOAL_PRIORITY = [
    {
        id:'HIGH',
        name:"High"
    },
    {
        id:'MEDIUM',
        name:"Medium"
    },
    {
        id:'LOW',
        name:"Low"
    }
];
export const GOAL_FILTER_CONSTANT = {
    SPECIFIC: 'SPECIFIC',
    TEAM: 'TEAM',
    DESIGNATION: "DESIGNATION"
}
export const GOAL_FILTER = [
    {
        id: GOAL_FILTER_CONSTANT['SPECIFIC'],
        name:"Specific to employee"
    },
    {
        id: GOAL_FILTER_CONSTANT['TEAM'],
        name:"Specific team"
    },
    {
        id:GOAL_FILTER_CONSTANT['DESIGNATION'],
        name:"Designation"
    }
]
export const APPRAISAL_FRQUENCY = [
    { id: "QUARTERLY", name: "3 Months" },
    { id: "HALF_YEARLY", name: "6 Months" },
    { id: "YEARLY", name: "12 Months"}
];
export const GOAL_FORM_FIELD = [
    {
        key:"name",
        columnCode: "name",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Goal Name",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false
    },
    {
        key:"startDate",
        columnCode: "startDate",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Start Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false
    },
    {
        key:"dueDate",
        columnCode: "dueDate",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Due Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false
    },
    {
        key:"description",
        columnCode: "description",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Description",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:false,
        readOnly: false
    },
    {
        key:"priority",
        columnCode: "priority",
        options:GOAL_PRIORITY,
        icon:"",
        validation:null,
        isValid:true,
        name:"Priority",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false
    },
    {
        key:"progress",
        columnCode: "progress",
        options:[],
        icon:"",
        validation:{
            regExp: PERCENTAGE
        },
        isValid:true,
        name:"Progress",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        hidden:true
    },
    {
        key:"filter",
        columnCode: "filter",
        options:GOAL_FILTER,
        icon:"",
        validation:null,
        isValid:true,
        name:"Filter",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false
    },
    {
        key:"specificTeam",
        columnCode: "specificTeam",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Teams",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        hidden:false
    },
    {
        key:"specificDesignation",
        columnCode: "specificDesignation",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Designations",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        hidden:false
    },
    {
        key:"applicableTo",
        columnCode: "applicableTo",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Applicable To",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        multiSelect:true
    }
    
];
export const getGoalPriorityIcon = (goal) => {
    switch(goal.priority) {
        case "HIGH":
            return HIGH;
        case "MEDIUM":
            return MEDIUM;
        case "LOW":
            return LOW;
    }
}
export const flipCard = (goalClassName) => {
    var cards = document.querySelectorAll(`.${goalClassName}`);
    if(cards && cards[0]) {

        cards[0].classList.toggle('is-flipped');
    }
    
}
export const renderGoal = (goal, index, params ) => {
    const assessmentType = params.selfAssessment ? params.selfAssessment : ""
    let commentValue = '';
    return (
        <div className="ml-l scene scene--card">
            <div className={` p-l mt-l goal-card goal_card_${goal?.name?.replace(/ /g,'')}${assessmentType} bg-white border-m border-radius-m`}>
                <div className="card__face card__face--front">
                    <div className="card-content">
                        <div className="row justify-content-between">
                            <div className="row">
                                <DKIcon style={{
                                    transform: `rotateZ(${goal?.priority === 'HIGH' ? "270" : "90"}deg)`
                                }} src={getGoalPriorityIcon(goal)} />
                                <DKLabel text={goal?.priority} />
                            </div>
                            <DKButton className="text-app" title="View Comments" onClick={() => { 
                                
                                flipCard(`goal_card_${goal?.name?.replace(/ /g,'')}${assessmentType} `)
                                scrollToBottomComment(`goal_card_id${goal?.name?.replace(/ /g,'')}${assessmentType}`)
                            }} />

                        </div>
                    <div style={{ minHeight: 60 }}>
                        <DKLabel className="fw-m line-clamp lc-2 m-v-s" text={goal?.name} />
                        <DKLabel className=" text-gray line-clamp lc-2  m-v-s" text={goal?.description} />
                    </div>
                    <DKLabel className=" text-gray  mt-xl" text={'Goal Period'} />
                    <DKLabel className="   mt-s" text={`${Utility.formatDate(moment(goal?.startDate), DATE_FORMAT.YYYYMMDD)} - ${Utility.formatDate(moment(goal.dueDate), DATE_FORMAT.YYYYMMDD)}`} />

                    <div className="row justify-content-between mt-m">
                        <DKLabel text={`Progress`} className="fs-m fw-b m-v-s" />
                        <DKLabel text={`${goal.progress || 0}%`} className="fs-m fw-b m-v-s" />
                    </div>
                    <div style={{ pointerEvents: params.readOnly ? "none" : "" }} >
                        <Range
                            value={goal.progress || 0}
                            trackColor={params.trackColor}
                            fillColor={params.fillColor}
                            height={5}
                            width="100%"
                            onChange={(value) => { params.progressChange(value, index) }}
                        />
                    </div>
                    </div>
                </div>

                <div class="card__face card__face--back">
                    <div className="card-content">
                        <div className="row justify-content-between">
                            <DKLabel text="Comments" />
                            <DKButton className="text-app" title="View Goal" onClick={() => {
                                
                                flipCard(`goal_card_${goal.name?.replace(/ /g, '')}${assessmentType} `)
                            }} />
                        </div>
                        
                        <div className={`custom-scroll comments-list`} id={`goal_card_id${goal.name?.replace(/ /g,'')}${assessmentType}`} >
                            {goal?.comments?.map(c=>{
                                return <div className="bg-gray1 border-radius-m border-m p-s m-v-s">{c.comment}</div>
                            })}
                            {!goal.comments && <DKLabel className="d-flex justify-content-center" text="No Comment added..."/>}
                        </div>

                        {!params.readOnly && <>
                            <DKInput
                                title={''}
                                type={INPUT_TYPE.TEXT}
                                value={commentValue}
                                placeholder={'Add your comment...'}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={params.readOnly}
                                required={false}
                                invalid={false}
                                canValidate={false}
                                onChange={(value) => {
                                    commentValue = value?.trim()
                                }}
                            />
                            <div className="row mt-s">
                                <DKButton className="bg-app text-white" title="Add" onClick={()=>{
                                    params.putComment(commentValue, index);
                                    scrollToBottomComment(`goal_card_id${goal.name?.replace(/ /g,'')}${assessmentType}`)
                                }}/>
                                <DKButton className="bg-gray1 border-m ml-s" title="Cancel" onClick={()=>flipCard(`goal_card_${goal.name?.replace(/ /g, '')}${assessmentType} `)}/>

                            </div>
                        </>}

                    </div>
                </div>
            </div>

        </div>
    )
}
const scrollToBottomComment = (id) => {
    setTimeout(() => {
      const holder = document.getElementById(id);
      if (holder) {
        holder.scrollTop = holder.scrollHeight;
      }
    }, 100);
  };
  export const APPRAISAL_CYCLE_FORM_FIELD = [
    {
        key:"name",
        columnCode: "name",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Appraisal Cycle Name",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false
    },
    {
        key:"dueDate",
        columnCode: "dueDate",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Due Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false
    },
    {
        key:"frequency",
        columnCode: "frequency",
        options: APPRAISAL_FRQUENCY,
        icon:"",
        validation:null,
        isValid:true,
        name:"Frequency",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false
    },
    {
        key:"description",
        columnCode: "description",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Description",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false
    },
    {
        key:"filter",
        columnCode: "filter",
        options:GOAL_FILTER,
        icon:"",
        validation:null,
        isValid:true,
        name:"Filter",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false
    },
    {
        key:"specificTeam",
        columnCode: "specificTeam",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Teams",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        hidden:false
    },
    {
        key:"specificDesignation",
        columnCode: "specificDesignation",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Designations",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        hidden:false
    },
    {
        key:"applicableTo",
        columnCode: "applicableTo",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Applicable To",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        multiSelect:true
    }
    
];
export const APPRAISERS_FIELD = [
    {
        key:"hasSelfAssessmentPeriod",
        columnCode: "hasSelfAssessmentPeriod",
        name:"Self Assessment",
        type:INPUT_TYPE.CHECKBOX,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false
    },
    {
        key:"selfAssessmentStartDate",
        columnCode: "selfAssessmentStartDate",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Start Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false
    },
    {
        key:"selfAssessmentDueDate",
        columnCode: "selfAssessmentDueDate",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Due Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false
    },
    {
        key:"hasReportingManagers",
        columnCode: "hasReportingManagers",
        name:"Reporting Managers",
        secondoryName:"Specific User",
        type:INPUT_TYPE.TOGGLE,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false
    },
    {
        key:"reportingManagers",
        columnCode: "reportingManagers",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Select User",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: true,
        multiSelect:true
    }
    
];
